import { Tooltip } from "@mui/material";

/**
 * Renders the Klaviyo customer-segment badges captured on an order
 * (orders.klaviyo_segments — a comma-joined string of segment names).
 *
 * Piggybacks on the existing order product-image badge flow (the !!! / ! / S
 * marks): one compact circular mark per segment showing its initial, with the
 * full segment name revealed on hover. Renders nothing when there are no
 * segments. Inline-styled so it looks identical across every order page
 * without touching each scss module.
 */
const SegmentBadge = ({ segments }) => {
  if (!segments || typeof segments !== "string") return null;

  const names = segments
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  if (names.length === 0) return null;

  return (
    <span style={{ display: "inline-flex", flexWrap: "wrap", gap: "2px" }}>
      {names.map((name, i) => (
        <Tooltip key={i} title={name} arrow placement="top">
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "16px",
              height: "16px",
              padding: "0 3px",
              borderRadius: "50%",
              background: "#c2185b",
              color: "#fff",
              fontSize: "10px",
              fontWeight: 700,
              textTransform: "uppercase",
              cursor: "default",
            }}
          >
            {name.charAt(0)}
          </span>
        </Tooltip>
      ))}
    </span>
  );
};

export default SegmentBadge;
